import {Http} from "../Http";
import {ServiceDto} from "../../../Api/Model/ServiceDto.csharp";
import {SpecializationDto} from "../../../Api/Model/SpecializationDto.csharp";
import { ServiceGroupDto } from "@apiModels/ServiceGroupDto.csharp";
import { ServiceContainerDto } from "@apiModels/ServiceContainerDto.csharp";
import { TreatmentsContainerDto } from "@apiModels/TreatmentsContainerDto.csharp";

export interface ITreatmentsApi {
    getSpecializations(): Promise<SpecializationDto[]>;
    getServices(): Promise<ServiceDto[]>;
}

export class TreatmentsApi implements ITreatmentsApi {
    public getSpecializations = (): Promise<SpecializationDto[]> => {
        return Http.get(`/api/specializations`, null) as Promise<SpecializationDto[]>;
    };
    public getServices = (): Promise<ServiceDto[]> => {
        return Http.get(`/api/services`, null) as Promise<ServiceDto[]>;
    };
    public getServiceGroups = (): Promise<ServiceGroupDto[]> => {
        return Http.get(`/api/service-groups`, null) as Promise<ServiceGroupDto[]>;
    };
}


export interface INewTreatmentsApi {
    getTreatments(): Promise<(TreatmentsContainerDto | ServiceContainerDto)[]>;
}

export class NewTreatmentsApi implements INewTreatmentsApi {
    public getTreatments = (): Promise<(TreatmentsContainerDto | ServiceContainerDto)[]> => {
        return Http.get(`/api/v2/treatments`, null) as Promise<(TreatmentsContainerDto | ServiceContainerDto)[]>;
    };
}
